require('./index.jade')
require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/auth/auth-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/analysis-charts/analysis-charts-module')
require('../components/error-handler/error-handler-module')
require('../components/analyze-access/analyze-access-module')

# Load Css
require('../../../sass/web/html/_profile.scss')

ProfileCtrl = require('./index-controller')
ProfileService = require('./profile-service')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-auth'
  'gnp-common-wrapper'
  'gnp-analysis-charts'
  'gnp-error-handler'
  'gnp-analyze-access'
]
angular.module 'gnp-app-profile', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/profile/:user_id',
      templateUrl: 'web/profile/index.jade'
      controller: 'ProfileCtrl'
      title: '_PROFILE.TITLE'
      resolve:
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
      permission:
        signInRequired: false
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'ProfileCtrl', ProfileCtrl
  .factory 'ProfileService', ProfileService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/profile/index-module.coffee